export var ActiveTabIndexEnum;
(function (ActiveTabIndexEnum) {
    ActiveTabIndexEnum[ActiveTabIndexEnum["VariableView"] = 0] = "VariableView";
    ActiveTabIndexEnum[ActiveTabIndexEnum["AlarmView"] = 1] = "AlarmView";
    ActiveTabIndexEnum[ActiveTabIndexEnum["HistoryDataView"] = 2] = "HistoryDataView";
    ActiveTabIndexEnum[ActiveTabIndexEnum["EdgeComputing"] = 3] = "EdgeComputing";
})(ActiveTabIndexEnum || (ActiveTabIndexEnum = {}));
